import React from "react";
import {Select} from "antd";
import {SelectField} from "./EligibleCourierSelect.styles";
import {useStore} from "../../../hooks/useStore";
import {courierStatusColors, courierStatuses} from "../../../constants/constants";
import {useFetch} from "../../../hooks/useFetch";

export const EligibleCourierSelect = ({
    subCompanyId,
    courierType,
    value,
    onChange,
    disabled = false,
    initialCall = false,
    excludedCouriers = [],
    mode = undefined,
    allowClear = false,
    strict = undefined,
    placeholder = "Atanacak Kurye",
    allPoolCouriers
}) => {
    const stores = useStore();

    const [couriersLoading, couriers] = useFetch({
        defaultDataValue: [],
        fetchFn: stores.courierStore.getAvailableCouriersForPreferredCourier.bind(null, {
            subCompanyId,
            courierType,
            strict,
            allPoolCouriers
        }),
        dependencies: [subCompanyId, courierType],
        initialCall: Boolean(subCompanyId) && Boolean(courierType) && initialCall,
        condition: Boolean(subCompanyId) && Boolean(courierType)
    });

    return (
        <>
            <SelectField
                placeholder={placeholder}
                name="availableCourierSelect"
                data-testid="availableCourierSelect"
                value={value}
                onChange={onChange}
                loading={couriersLoading}
                disabled={couriersLoading || disabled}
                mode={mode}
                allowClear={allowClear}
            >
                {couriers
                    ?.filter(courier => !excludedCouriers.includes(courier?.id?.toString()))
                    .map(courier => {
                        return (
                            <Select.Option
                                key={courier.id}
                                value={courier.id}
                                style={{
                                    color: courierStatusColors[courier.status]
                                }}
                            >
                                {`${courier.name} - ${
                                    courierStatuses.find(c => c.value == courier.status).name
                                } - ${courier.distance?.toFixed(1)} km`}
                            </Select.Option>
                        );
                    })}
            </SelectField>
        </>
    );
};
